// react
import { useCallback, useEffect } from 'react';
// services
import { InvestorsService, IncubatorService } from '@/services';
// hooks
import { useModal } from '@/hooks';
// enums
import { USER_GROUP_TYPE } from '@/enums';

export default function InviteOnlyPitchEventRegisterModal({
  open,
  setOpen,
  userGroupId,
  contentId,
  userGroupType,
  mutate,
}) {
  const {
    applyToPitch: { setOpen: setApplyToPitchModalOpen, setProps: setApplyToPitchModalProps },
  } = useModal();

  const handleApplyToPitch = useCallback(async () => {
    if (userGroupType === USER_GROUP_TYPE.INVESTOR) {
      var { success, data = [] } = await InvestorsService.postApplyToPitch(userGroupId);
    }
    if (userGroupType === USER_GROUP_TYPE.INCUBATOR) {
      var { success, data = [] } = await IncubatorService.getApplyToIncubator(userGroupId);
    }
    if (success) {
      setApplyToPitchModalProps({
        applyToPitchData: data,
        userGroupType,
        userGroupId,
        contentId,
        announcementId: null,
        onSuccess: mutate,
      });
      setApplyToPitchModalOpen(true);
    }
  }, [
    userGroupType,
    userGroupId,
    setApplyToPitchModalProps,
    contentId,
    mutate,
    setApplyToPitchModalOpen,
  ]);

  useEffect(() => {
    if (open) {
      handleApplyToPitch();
      setOpen(false);
    }
  }, [handleApplyToPitch, open, setOpen]);
  return <></>;
}
